import request from '@/utils/request'


// 查询学校校服专区列表
export function listSchoolArea(query) {
  return request({
    url: '/biz/admin/school/area/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询学校校服专区详细
export function getSchoolArea(data) {
  return request({
    url: '/biz/admin/school/area/detail',
    method: 'get',
    params: data
  })
}

// 新增学校校服专区
export function addSchoolArea(data) {
  return request({
    url: '/biz/admin/school/area/add',
    method: 'post',
    data: data
  })
}

// 修改学校校服专区
export function updateSchoolArea(data) {
  return request({
    url: '/biz/admin/school/area/edit',
    method: 'post',
    data: data
  })
}

// 删除学校校服专区
export function delSchoolArea(data) {
  return request({
    url: '/biz/admin/school/area/delete',
    method: 'post',
    data: data
  })
}
